<template>
  <div>
    <v-row class="mx-1" justify="center">
      <v-col cols="12" md="12" sm="12" class="cus-products">
        <base-title-bar
          elevation="3"
          class="text-center"
          color="blue white--text"
          :label="depthChart.FullName"
        />

        <v-sheet elevation="2" rounded class="px-1">
          <v-row justify="center" class="py-1 my-1" no-gutters>
            <!-- //! LW -->
            <v-col cols="4" md="4" sm="4">
              <v-sheet
                color="#B0BEC5"
                class="text-center ml-1 py-1 font-weight-bold d-flex align-center justify-center"
                >LW
              </v-sheet>
              <div v-for="player in depthChart.LWarr" :key="player.Name">
                <v-col cols="12" md="12" sm="12" class="text-center">
                  <v-avatar width="120" height="100" tile>
                    <img :src="depthChart.Jersey_Image" />
                  </v-avatar>
                </v-col>

                <v-col cols="12" md="12" sm="12" class="mt-n5 text-center">
                  <router-link
                    :to="{
                      name: 'PlayerDetail',
                      params: {
                        playerId: player.PlayerID,
                        SportId: 3,
                      },
                    }"
                    style="text-decoration: none"
                    class="caption"
                  >
                    <p>{{ player.Name }}</p>
                  </router-link>
                </v-col>
              </div>
            </v-col>

            <!-- //! C -->
            <v-col cols="4" md="4" sm="4">
              <v-sheet
                color="#B0BEC5"
                class="text-center ml-1 py-1 font-weight-bold d-flex align-center justify-center"
                >C
              </v-sheet>

              <div v-for="player in depthChart.Carr" :key="player.Name">
                <v-col cols="12" md="12" sm="13" class="text-center">
                  <v-avatar width="120" height="100" tile>
                    <img :src="depthChart.Jersey_Image" />
                  </v-avatar>
                </v-col>

                <v-col cols="12" md="12" sm="12" class="mt-n5 text-center">
                  <router-link
                    :to="{
                      name: 'PlayerDetail',
                      params: {
                        playerId: player.PlayerID,
                        SportId: 3,
                      },
                    }"
                    style="text-decoration: none"
                    class="caption"
                  >
                    <p>{{ player.Name }}</p>
                  </router-link>
                </v-col>
              </div>
            </v-col>

            <!-- //! RW -->
            <v-col cols="4" md="4" sm="4">
              <v-sheet
                color="#B0BEC5"
                class="text-center ml-1 py-1 font-weight-bold d-flex align-center justify-center"
                >RW
              </v-sheet>

              <div v-for="player in depthChart.RWarr" :key="player.Name">
                <v-col cols="12" md="12" sm="13" class="text-center">
                  <v-avatar width="120" height="100" tile>
                    <img :src="depthChart.Jersey_Image" />
                  </v-avatar>
                </v-col>

                <v-col cols="12" md="12" sm="12" class="mt-n5 text-center">
                  <router-link
                    :to="{
                      name: 'PlayerDetail',
                      params: {
                        playerId: player.PlayerID,
                        SportId: 3,
                      },
                    }"
                    style="text-decoration: none"
                    class="caption"
                  >
                    <p>{{ player.Name }}</p>
                  </router-link>
                </v-col>
              </div>
            </v-col>
          </v-row>

          <!-- //! Defensive -->
          <v-row justify="center" class="py-1 my-1" no-gutters>
            <!--LD-->
            <v-col cols="6" md="6" sm="6">
              <v-sheet
                color="#B0BEC5"
                class="text-center ml-1 py-1 font-weight-bold d-flex align-center justify-center"
                >LD
              </v-sheet>

              <div v-for="player in depthChart.LDarr" :key="player.Name">
                <v-col cols="12" md="12" sm="13" class="text-center">
                  <v-avatar width="120" height="100" tile>
                    <img :src="depthChart.Jersey_Image" />
                  </v-avatar>
                </v-col>

                <v-col cols="12" md="12" sm="12" class="mt-n5 text-center">
                  <router-link
                    :to="{
                      name: 'PlayerDetail',
                      params: {
                        playerId: player.PlayerID,
                        SportId: 3,
                      },
                    }"
                    style="text-decoration: none"
                    class="caption"
                  >
                    <p>{{ player.Name }}</p>
                  </router-link>
                </v-col>
              </div>
            </v-col>

            <!--RD-->
            <v-col cols="6" md="6" sm="6">
              <v-sheet
                color="#B0BEC5"
                class="text-center ml-1 py-1 font-weight-bold d-flex align-center justify-center"
                >RD
              </v-sheet>

              <div v-for="player in depthChart.RDarr" :key="player.Name">
                <v-col cols="12" md="12" sm="13" class="text-center">
                  <v-avatar width="120" height="100" tile>
                    <img :src="depthChart.Jersey_Image" />
                  </v-avatar>
                </v-col>

                <v-col cols="12" md="12" sm="12" class="mt-n5 text-center">
                  <router-link
                    :to="{
                      name: 'PlayerDetail',
                      params: {
                        playerId: player.PlayerID,
                        SportId: 3,
                      },
                    }"
                    style="text-decoration: none"
                    class="caption"
                  >
                    <p>{{ player.Name }}</p>
                  </router-link>
                </v-col>
              </div>
            </v-col>
          </v-row>

          <!-- //! 1ST POWERPLAY UNIT -->
          <v-row justify="center" class="py-1 my-1" no-gutters>
            <v-col>
              <v-sheet
                color="#B0BEC5"
                class="text-center ml-1 py-1 font-weight-bold d-flex align-center justify-center"
                >1ST POWERPLAY UNIT
              </v-sheet>

              <v-row justify="space-around">
                <v-col
                  cols="6"
                  md="6"
                  sm="6"
                  v-for="player in depthChart.PP1arr"
                  :key="player.Name"
                >
                  <v-col cols="12" md="12" sm="12" class="text-center">
                    <v-avatar width="120" height="100" tile>
                      <img :src="depthChart.Jersey_Image" />
                    </v-avatar>
                  </v-col>

                  <v-col cols="12" md="12" sm="12" class="mt-n5 text-center">
                    <router-link
                      :to="{
                        name: 'PlayerDetail',
                        params: {
                          playerId: player.PlayerID,
                          SportId: 3,
                        },
                      }"
                      style="text-decoration: none"
                      class="caption"
                    >
                      <p>{{ player.Name }}</p>
                    </router-link>
                  </v-col>
                </v-col>
              </v-row>
            </v-col>
          </v-row>

          <!-- //! 2nd POWERPLAY UNIT -->
          <v-row justify="center" class="py-1 my-1" no-gutters>
            <v-col>
              <v-sheet
                color="#B0BEC5"
                class="text-center ml-1 py-1 font-weight-bold d-flex align-center justify-center"
                >2nd POWERPLAY UNIT
              </v-sheet>

              <v-row justify="space-around">
                <v-col
                  cols="6"
                  md="6"
                  sm="6"
                  v-for="player in depthChart.PP2arr"
                  :key="player.Name"
                >
                  <v-col cols="12" md="12" sm="12" class="text-center">
                    <v-avatar width="120" height="100" tile>
                      <img :src="depthChart.Jersey_Image" />
                    </v-avatar>
                  </v-col>

                  <v-col cols="12" md="12" sm="12" class="mt-n5 text-center">
                    <router-link
                      :to="{
                        name: 'PlayerDetail',
                        params: {
                          playerId: player.PlayerID,
                          SportId: 3,
                        },
                      }"
                      style="text-decoration: none"
                      class="caption"
                    >
                      <p>{{ player.Name }}</p>
                    </router-link>
                  </v-col>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-sheet>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "lineCombination",
  props: {
    depthChart: {
      type: [Array, Object],
      default: () => [],
    },
  },
};
</script>

<style></style>
